// Global error handlers for iOS crash debugging - MUST be first!
window.addEventListener('error', (event) => {
  console.error('[BOOT] Window error:', {
    message: event.error?.message || event.message,
    stack: event.error?.stack,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[BOOT] Unhandled rejection:', event.reason);
});

console.log('[BOOT] Error handlers registered');

import "./polyfills/safe-storage";
import { createRoot } from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/contexts/AuthContext";
import { NotificationProvider } from "@/providers/NotificationProvider";
import App from "./App.tsx";
import "./index.css";

console.log('[BOOT] All imports loaded successfully');

const queryClient = new QueryClient();

// Use HashRouter for native apps, BrowserRouter for web

// Normalize router mode for native
const isNative = Capacitor.isNativePlatform();
let routerLabel = isNative ? 'HashRouter' : 'BrowserRouter';
const routerMap = {
  'HashRouter': HashRouter,
  'BrowserRouter': BrowserRouter,
};
let RouterImpl = routerMap[routerLabel];
if (!RouterImpl) {
  console.error('[ROUTER GUARD TRIGGERED]', { routerLabel, routerMap, platform: isNative ? 'native' : 'web' });
  // Fail-soft: fallback to HashRouter
  RouterImpl = HashRouter;
}
console.log('[BOOT] Using router:', routerLabel, '| platform:', isNative ? 'native' : 'web');
console.log('[BOOT] React root rendering started...');

createRoot(document.getElementById("root")!).render(
  <RouterImpl>
    <App />
  </RouterImpl>
);
